import { CheckboxColor } from "@/common/enum/checkbox-color";
import { formatCommasNumber } from "@/common/util/format-number-with-commas";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strikethrough } from "@/components/typography/Body14Strikethrough";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Checkbox, Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";

interface Props {
  item: ItemDetailDto;
  checkedItemIds: number[];
  handleCheckItem: (itemId: number) => void;
}

export const ItemAllDiscountsTableRow: React.FC<Props> = ({
  item,
  checkedItemIds,
  handleCheckItem,
}) => {
  const isChecked = checkedItemIds.includes(item.id);
  return (
    <Table.Row
      key={item.id}
      className="bg-white dark:border-gray-700 dark:bg-gray-800"
    >
      <Table.Cell>
        <CustomCell>
          <Checkbox
            color={isChecked ? CheckboxColor.DARK : ""}
            checked={isChecked}
            onChange={() => handleCheckItem(item.id)}
          />
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.name}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body max-w-[128px] overflow-hidden text-ellipsis whitespace-nowrap">
            {item.modelName}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.erpCode}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.category.name}
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell>
        <CustomCell>
          <Body14Regular className="text-semantic-text-body">
            {item.discountRate}%
          </Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="flex flex-col ml-[16px]">
        <Body14Strikethrough className="text-semantic-text-disabled mt-[4px] mb-[2px]">
          {formatCommasNumber(item.price)}
        </Body14Strikethrough>
        <Body14Regular className="text-semantic-text-body">
          {formatCommasNumber(item.priceBydefaultDiscount)}
        </Body14Regular>
      </Table.Cell>
    </Table.Row>
  );
};
